import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const billingTransactionMenuRegistry = {
    core_billingTransaction: {
        label: "Billing Transaction",
        link: PAGE_URL.BILLING_TRANSACTION_PAGE,
        key: PAGE_URL.BILLING_TRANSACTION_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default billingTransactionMenuRegistry;
